<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Detail.scss";
  .map-container{
    height: 380px;
  }
</style>
<template>
    <div class="item-grid-view vx-row match-height mt-4">
        <div class="lg:w-1/3 sm:w-1/2 w-full h-full">
            <div class="w-full grid-view-item h-full">
            <vx-card class=" overflow-hidden h-full">
                  <gridPrincipalItem
                    img="label"
                    :name="response.alias_label"
                    :description="$t('Labels.Alias')"
                    :name2="response.serie"
                    :description2="$t('Labels.Serie')"
                  ></gridPrincipalItem>
                  <div class="absolute right-0 top-0">
                      <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="goToConfig()" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-settings" icon-pack="feather" type="border">
                      </vs-button>
                      <vs-button v-if="$store.state.AppActiveUser.userRole === 'MA'" @click="assign(uuid)" class="watersonic edit-button mr-2 mt-2" color="grey" icon="icon-plus-circle" icon-pack="feather" type="border">
                      </vs-button>
                  </div>
                  <vs-divider/>
                  <div v-if="response.alias_device === '' || response.alias_device === undefined">
                    <div class="text-center text-2xl mb-5">{{$t('Labels.NotAssigned')}}</div>
                  </div>
                  <div v-else>
                    <div class="text-center text-2xl mb-5">{{$t('Labels.Assigned')}}</div>
                    <valueItem :description="$tc('Devices',1)" img="cpu" :value="response.alias_device"></valueItem>
                    <valueItem :description="$t('Labels.Type')" img="cpu" :value="response.type"></valueItem>
                    <div class="block text-center p-2">
                    <vx-card class="w-64 m-auto">
                        <div class="block text-center">
                            <div class="inline-block align-middle">
                                <div  class="inline-block align-middle">
                                    <img class="h-12 d-theme-dark-bg" v-bind:src="getIcon(response.status)"/>
                                </div>
                                <div  class="inline-block text-xl ml-3 align-middle">{{getMessage(response.status)}}</div>
                            </div>
                        </div>
                    </vx-card>
                    </div>
                  </div>
                </vx-card>
            </div>
        </div>
        <div class="vx-col lg:w-2/3 sm:w-2/3 w-full mt-2 sm:mt-0">
            <vx-card class="grid-view-item mb-base overflow-hidden address-card">
                <div class="avatar-info-container">
                    <span class="account-number">
                      {{$t("Labels.DeviceLocation")}}
                    </span>
                    <feather-icon
                        icon="EditIcon"
                        @click="editMap = true"
                        class="float-right cursor-pointer"
                        svgClasses="hover:text-primary"
                        v-if="!editMap && $store.state.AppActiveUser.userRole === 'MA'"/>
                    <feather-icon
                      icon="SaveIcon"
                      @click="saveMap()"
                      class="float-right cursor-pointer"
                      svgClasses="hover:text-primary"
                      v-if="editMap"/>
                   <div class="map-container basic-example" v-if="status_mapa">
                        <l-map style="height: 100%; overflow: hidden;" :zoom="18" :center="center" ref="mymap" :options="{ zoomControl: false, dragging: false}">
                            <l-tile-layer
                                v-for="tileProvider in tileProviders"
                                :key="tileProvider.name"
                                :name="tileProvider.name"
                                :visible="tileProvider.visible"
                                :url="tileProvider.url"
                                layer-type="base"
                            />
                            <l-marker :draggable="editMap" :lat-lng="marker.position" ref="position_marker">
                                <l-icon :icon-anchor="staticAnchor">
                                    <img :src="require(`@/assets/images/markers/0.svg`)" width="25px;" alt="ícono marcador"/>
                                </l-icon>
                            </l-marker>

                        </l-map>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>
<script>
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
import { request } from '@/request.js'
import { empty } from '@/helpers.js'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'

const tileProviders = [
  {
    name: 'Gris',
    visible: true,
    url: 'https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
  },
  {
    name: 'Calles',
    visible: false,
    url: 'https://{s}.tile.openstreetmap.fr/osmfr//{z}/{x}/{y}.png'
  },
  {
    name: 'Satelite',
    visible: false,
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png'
  }
]

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    gridPrincipalItem,
    valueItem
  },
  data () {
    return {
      tileProviders,
      layersPosition: 'topright',
      center: [],
      staticAnchor: [12, 27],
      customText: 'Temperatura ambiental',
      clusterOptions: {},
      imagePath: 'images/vendor/leaflet/dist/',
      response: {
        status: '1'
      },
      marker: {},
      status_mapa: false,
      status_heat: false,
      status_filtrar: false,
      label: {
        device_name: 'sin alerta',
        value: []
      },
      editMap: false,
      uuid: this.$route.params.uuid
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()
      const params = {
        url: `modelo/labels/${this.$route.params.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        if (!empty(response.data.data)) {
          this.response = response.data.data
          const [lat, lng] = this.response.location_label.split(',')
          this.center = [lat, lng]
          this.marker = {
            position: { lat: lat, lng: lng },
            tooltip: response.data.data.alias_label,
            draggable: false,
            visible: true
          }
          this.status_mapa = true
        }
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToConfig () {
      window.location.href = `/labels/config/${this.$route.params.uuid}`
    },

    getImgUrl (name) {
      let img = ''
      switch (name) {
        case 'Temperatura y Humedad':
          img = 'envtemperature'
          break
        case 'Puertas':
          img = 'doors'
          break
        case 'Energia':
          img = 'energy'
          break
        case 'Flujo de Aire':
          img = 'airflow'
          break
        default:
          break
      }
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${img}.svg`)
    },
    getIcon (status) {
      status = status - 1
      const img = [
        'no_alert',
        'cold',
        'hot',
        'pressure_label',
        'pressure_label',
        'energy_label',
        'energy_label',
        'humidity',
        'humidity',
        'open',
        'clock_alert',
        'error'
      ]
      if (status < 0 || status > 10) { status = 11 }
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${img[parseInt(status)]}.svg`)
    },
    getMessage (status) {
      status = status - 1
      const message = [
        'Normal',
        'Temperatura baja',
        'Temperatura alta',
        'Presion baja',
        'Presion alta',
        'Sobrecarga de energia',
        'Perdida de energia',
        'Humedad alta',
        'Humedad baja',
        'Apertura',
        'Apertura prolongada',
        'Error'
      ]
      return message[parseInt(status)]
    },
    assign (idGateway) {
      window.location.href = `/labels/assign/${idGateway}`
    },
    async saveMap () {
      const location = this.$refs.position_marker.mapObject.getLatLng()
      this.response.location = `${location.lat},${location.lng}`
      const params = {
        url: `modelo/labels/${this.$route.params.uuid}`,
        method: 'PUT',
        params: this.response
      }
      await request(params).then(() => {
        this.editMap = false
      })
    }
  },
  created () {
    this.getResponse()
  }
}
</script>
<style scoped="">
  .vue2leaflet-map >>> .leaflet-shadow-pane {
    display: none !important;
  }
>>>.vs-input--label {
    padding: 0;
  }
</style>
